import is from "./is.js";
export default (...args) => 
// deno-lint-ignore ban-types
(Cls) => {
    is(...args.map((event) => "sub:" + event))(Cls);
};
